import script from "./change_pwd.vue?vue&type=script&setup=true&lang=js"
export * from "./change_pwd.vue?vue&type=script&setup=true&lang=js"

import "./change_pwd.vue?vue&type=style&index=0&id=2482d7a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2482d7a8"]])

export default __exports__